<a class="download-link" (click)="downloadTemplate()">Template</a>
